import * as React from 'react';
import { ElementType, FunctionComponent, useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { TabsProps } from '@mui/material/Tabs';

import StyledTypography from '../../../../shared/components/styled-typography/styled-typography';
import { useNavigateToFirstTab } from '../../../../shared/hooks/use-navigate-to-first-tab/use-navigate-to-first-tab.hook';
import { useAppDispatch } from '../../../../store/hooks';
import Modal from '../../../shared/components/modal/Modal';
import { ModalContext } from '../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../shared/components/modal/models/modal-context.model';
import NavTab from '../../../shared/components/nav-tab/NavTab';
import { useQueryParams } from '../../../shared/hooks/use-query-params/use-query-params.hook';
import { resetBasicInfo } from '../../store/slices/campaigns-basic-info.slice';
import { resetVehiclePopulation } from '../../store/slices/campaigns-vehicle-population.slice';
import StyledPaper from './components/styled-paper/styled-paper';

const CampaignCreateLayout: FunctionComponent = (): JSX.Element => {
  const location = useLocation();
  const ctx = useContext(ModalContext) as ModalContextModel;
  const isOnCreate = location.pathname.startsWith(
    '/campaign-management/create'
  );
  const queryParams = useQueryParams();
  const campaignCreated = queryParams['campaignCreated'] === 1;
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetBasicInfo());
      dispatch(resetVehiclePopulation());
    };
  }, []);

  const tabs: TabsProps<ElementType>[] = [
    {
      label: 'Basic Information',
      value: 'basic-information',
      to: 'basic-information',
    },
    {
      label: 'Vehicle Population',
      value: 'vehicle-population',
      to: 'vehicle-population',
    },
    {
      label: 'Reports',
      value: 'reports',
      to: 'reports',
      sx: {
        ...(isOnCreate && {
          opacity: 0.5,
          pointerEvents: 'none',
        }),
      },
    },
  ];

  useNavigateToFirstTab(tabs);

  return (
    <>
      <StyledTypography variant="h1">
        {isOnCreate || campaignCreated ? 'New Campaign' : 'Update Campaign'}
      </StyledTypography>

      <StyledPaper data-testid="create-new-campaign">
        <NavTab tabs={tabs} />
      </StyledPaper>

      <Outlet />

      <Modal>{ctx.component}</Modal>
    </>
  );
};

export default CampaignCreateLayout;
